import React, { useEffect, useState } from "react";
import "./style.css";
import { Button, Col, Form, Input, Row, notification } from "antd";
import { updateSettings } from "../../../../api/settings";
import { useSelector } from "react-redux";

const General = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { settings } = useSelector((state) => state.setting);

  const onFinish = async (values) => {
    setLoading(true);
    try {
        await updateSettings(values);
        setLoading(false);
        notification.success({
            message: "Success",
            description: "Settings updated successfully!",
        });
    } catch (error) {
        setLoading(false);
        notification.error({
            message: "Error",
            description: "An error occurred while updating settings.",
        });
    }
};

  useEffect(() => {
    form.setFieldValue("numberForSms", settings?.numberForSms || undefined);
    form.setFieldValue("numberForCall", settings?.numberForCall || undefined);
    form.setFieldValue("email", settings?.email || undefined);
    form.setFieldValue("subject", settings?.subject || undefined);
    form.setFieldValue("defaultMessage", settings?.defaultMessage || undefined);
  }, [settings]);

  return (
    <div className="general_tab_container">
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        requiredMark={false}
        autoComplete="off"
      >
        <Row gutter={[20, 0]}>
          <Col xs={24} md={7}>
            <Form.Item
              label="SMS recipient phone number"
              name="numberForSms"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col xs={24} md={7}>
            <Form.Item
              label="Call recipient phone number"
              name="numberForCall"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <h3 style={{ marginTop: "10px" }}>Email Info</h3>
          </Col>
          <Col xs={24} md={7}>
            <Form.Item
              label="Email recipient address"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input type="email" />
            </Form.Item>
          </Col>
          <Col xs={24} md={7}>
            <Form.Item
              label="Subject"
              name="subject"
              rules={[
                {
                  required: false,
                  message: "Required",
                },
              ]}
            >
              <Input type="text" />
            </Form.Item>
          </Col>
          <Col xs={24} md={14}>
            <Form.Item
              label="Default message"
              name="defaultMessage"
              rules={[
                {
                  required: false,
                  message: "Required",
                },
              ]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Button
              className="button"
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "200px", marginTop: "10px", height: "37px" }}
            >
              SAVE
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default General;
